import { IAddress } from "./address.types"

export class Address implements IAddress {
  countryCode: string
  postcode: string
  addressLine1: string
  addressLine2: string
  addressLine3: string

  constructor(
    countryCode: string,
    postcode: string,
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
  ) {
    this.countryCode = countryCode
    this.postcode = postcode
    this.addressLine1 = addressLine1
    this.addressLine2 = addressLine2
    this.addressLine3 = addressLine3
  }

  get formattedAddress() {
    const addressArray = [
      this.addressLine1,
      this.addressLine2,
      this.addressLine3,
      this.postcode,
      this.countryCode,
    ]
    return addressArray.filter((a) => !!a).join(", ")
  }
}

export const getEmptyAddress = () => new Address("", "", "", "", "")
